import { render, staticRenderFns } from "./KbWorkspace.vue?vue&type=template&id=74ed2750&scoped=true"
import script from "./KbWorkspace.vue?vue&type=script&lang=js"
export * from "./KbWorkspace.vue?vue&type=script&lang=js"
import style0 from "./KbWorkspace.vue?vue&type=style&index=0&id=74ed2750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ed2750",
  null
  
)

export default component.exports